import { Box, LinearProgress, Typography, linearProgressClasses, styled } from '@mui/material'
import React, { useState } from 'react'
import StartPage from '../components/StartPage'
import QuestionsPage from '../components/questionsPage'
import { test_questions } from '../components/questionsPage/test_questions'
import ExitPrompModal from '../components/ExitPrompModal'
import { useLocation } from 'react-router-dom'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  borderRadius: '4.5px',
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette['gray-line'].main,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: '4.5px',
    backgroundColor: theme.palette['alternate'].main,
  },
}))

const AssessmentQuestions = () => {
  const {
    state: { isRetake },
  } = useLocation()
  const [start, setStart] = useState(false)
  const [progress, setProgress] = useState(0)

  const totalLength = test_questions.reduce((total, item) => total + item.questions.length, 0)
  const totalAnswered = (progress / 100) * totalLength

  return (
    <Box
      sx={{
        backgroundColor: 'gray-background.main',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      {/* Header */}
      <Box width={'100%'} position={'sticky'} top={0}>
        <Box
          sx={{
            backgroundColor: 'white.main',
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 24px',
            borderBottom: '1px solid #E5E5E5',
          }}
        >
          <Typography variant="h4">Work Personality Fit</Typography>
          <Box display={'flex'} alignItems={'center'}>
            {start && (
              <Typography color={'alternate.main'}>{`${totalAnswered}/${totalLength}`}</Typography>
            )}
            <ExitPrompModal />
          </Box>
        </Box>
        {start && (
          <Box width={'100%'}>
            <BorderLinearProgress variant="determinate" value={progress} />
          </Box>
        )}
      </Box>

      {/* Questions component */}
      {!start ? (
        <StartPage setStart={setStart} />
      ) : (
        <QuestionsPage setProgress={setProgress} isRetake={isRetake} />
      )}
    </Box>
  )
}

export default AssessmentQuestions
